export default __webpack_public_path__ + "static/media/edir-camel.d8c387e0.png";